export const country = {
    "BELARUS": "Беларусь",
    "RUSSIA": "Россия",
    "KAZAKHSTAN": "Казахстан",
    "WORLD": "Другое"
};

export const countryOptions = Object.entries(country);